import React, { useEffect, useState } from "react";
import { useIngressesAndUploads } from "./lib/useIngressesAndUploads";
import { UploadStatus } from "lib/types/UploadStatus";
import UploadCompleteSvg from "components/icons/UploadIcons/upload-complete.svg";
import ProcessingStepSvg from "components/icons/UploadIcons/processing-step.svg";
import UploadingStepSvg from "components/icons/UploadIcons/uploading-step.svg";
import IngressJobsModal from "./IngressJobsModal";

type SpinnerStatus =
  | "idle"
  | "uploading"
  | "processing"
  | "complete"
  | undefined;

export default function IngressJobsButtonV2() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { ingressesAndUploads } = useIngressesAndUploads();

  const count = ingressesAndUploads.length;
  const countUploading = ingressesAndUploads.filter(
    (x) => x.uploadStatus !== UploadStatus.complete && x.uploadStatus !== null,
  ).length;
  const countProcessing = ingressesAndUploads.filter(
    (x) => x.ingressStatus === "processing",
  ).length;
  const countDone = ingressesAndUploads.filter(
    (x) =>
      x.ingressStatus === "done" ||
      x.ingressStatus === "error" ||
      x.ingressStatus === "partialError",
  ).length;

  let spinnerStatus: SpinnerStatus;
  if (count == 0) spinnerStatus = "idle";
  else if (countUploading > 0) spinnerStatus = "uploading";
  else if (countProcessing > 0) spinnerStatus = "processing";
  else if (countDone > 0) spinnerStatus = "complete";

  useEffect(() => {
    if (spinnerStatus === "uploading") setIsModalOpen(true);
  }, [spinnerStatus]);

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="flex h-9 w-9 items-center justify-center rounded-xl hover:bg-gray-200 focus:ring-0"
      >
        <IngressJobsHeaderIcon status={spinnerStatus} />
      </button>
      <IngressJobsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}

const IngressJobsHeaderIcon = (p: { status?: SpinnerStatus }) => {
  return (
    <>
      {(!p?.status || p.status === "idle") && (
        <UploadingStepSvg className="h-full w-6 brightness-0 saturate-0" />
      )}
      {p.status === "uploading" && (
        <UploadingStepSvg className="h-full w-6 text-gray-500" />
      )}
      {p.status === "processing" && (
        <ProcessingStepSvg className="h-full w-6 " />
      )}
      {p.status === "complete" && (
        <UploadCompleteSvg className="w-8 text-gray-500" />
      )}
    </>
  );
};
